'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();

import { analytics } from '@/lib/analytics/posthog'
import { useEffect, useRef } from 'react'

/**
 * Fires `section_viewed` once per pageview when the section it's mounted in first crosses 30%
 * into the viewport, then disconnects — a full scroll through the page produces at most one
 * event per section, not one per direction change as the reader scrolls back and forth over it.
 *
 * Renders as an absolutely-positioned sibling covering the whole section, so it must be mounted
 * inside a `relative` wrapper (the section's own root, or a dedicated wrapper around a
 * component-owned section that has no tracker slot) — the sentinel IS the section's visible area,
 * not a thin marker at its edge.
 */
export function SectionViewTracker({ section }: { section: string }) {
  const sentinelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const node = sentinelRef.current
    if (!node) {
      return
    }

    // A section taller than the viewport must still be trackable — cap the ratio so ~half a
    // viewport of visible section counts as viewed, rather than requiring 30% of a section that
    // can be several viewports tall on mobile.
    const threshold = node.offsetHeight > 0 ? Math.min(0.3, (0.5 * window.innerHeight) / node.offsetHeight) : 0.3

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          analytics.capture('section_viewed', { section })
          observer.disconnect()
        }
      },
      { threshold },
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [section])

  return <div ref={sentinelRef} aria-hidden="true" className="pointer-events-none absolute inset-0" />
}
